import { HttpInterceptorFn } from '@angular/common/http';

export const credentialsInterceptor: HttpInterceptorFn = (req, next) => {
  const authReq = req.clone({
    // CRITICAL: This sends the cookie
    withCredentials: true 
  });
  return next(authReq);
};